import type { THosOptions } from "hos-tools";
import { Entity } from "./Entity";

export interface IDeviceCustomPropertyValue {
    id?: string;
    property: {
        id: string;
        name?: string;
        propertyType?: string;
        externalReference?: string;
        isVisible?: boolean;
        minLength?: number;
        maxLength?: number;
        propertySet?: { id: string };
        version?: string;
    };
    value?: string | null;
}

export class Device extends Entity implements INamedEntity {

    name: string;
    comment: string;
    isHistoric: boolean;
    hardwareId: string;
    serialNumber: string;
    productId: number;
    timezoneId: string;
    deviceType: string;
    groups: IIdEntity[];
    vehicleIdentificationNumber: string;
    vinInfoMake?: string;
    vinInfoModel?: string;
    vinInfoYear?: string;
    licensePlate: string;
    licenseState: string;
    odometer: number;
    engineHours: number;
    activeFrom?: Date;
    activeTo?: Date;
    devicePlanBillingInfo?: IDevicePlanBillingInfo[];
    deviceFlags: IDeviceFlags;
    disableSleeperBerth?: boolean;
    autoHos?: THosOptions;
    tmpTrailerId?: string;
    customProperties?: IDeviceCustomPropertyValue[];


    constructor(obj?: any) {
        super(obj);

        this.name = obj?.name || "";
        this.comment = obj?.comment || "";
        this.serialNumber = obj?.serialNumber || "";
        this.isHistoric = obj?.isHistoric || null;
        this.hardwareId = obj?.hardwareId || null;
        this.productId = obj?.productId || null;
        this.timezoneId = obj?.timezoneId || "";
        this.deviceType = obj?.deviceType || "";
        this.groups = obj?.groups || [];
        this.vehicleIdentificationNumber = obj?.vehicleIdentificationNumber || "";
        this.vinInfoMake = obj?.vinInfoMake;
        this.vinInfoModel = obj?.vinInfoModel;
        this.vinInfoYear = obj?.vinInfoYear;
        this.licensePlate = obj?.licensePlate || "";
        this.licenseState = obj?.licenseState || "";
        this.odometer = obj?.odometer || 0;
        this.engineHours = obj?.engineHours || 0;
        this.deviceFlags = obj?.deviceFlags || null;
        this.devicePlanBillingInfo = obj?.devicePlanBillingInfo;
        this.autoHos = obj?.autoHos;
        this.tmpTrailerId = obj?.tmpTrailerId;
        this.disableSleeperBerth = obj?.disableSleeperBerth || null;
        this.activeFrom = obj ? this.parseDate(obj.activeFrom, "activeFrom") : undefined;
        this.activeTo = obj ? this.parseDate(obj.activeTo, "activeTo") : undefined;
        this.customProperties = obj?.customProperties;
    }
    private parseDate(dateStr: string | Date, propertyName: string): Date {
        if (typeof dateStr === "string") {
            const date = new Date(dateStr);
            if (date.toString() === "Invalid Date") {
                throw new Error(`${ propertyName } invalid date exception`);
            }
            return date;
        }
        return dateStr;
    }
}